import { MISSION_IMAGE } from "@/mock";
import { ShieldCheck, Recycle, Users } from "lucide-react";

const POINTS = [
  { icon: ShieldCheck, text: "Servicio oficial del Ayuntamiento, gratuito para empadronados/as" },
  { icon: Recycle, text: "Gestión responsable y sostenible de todos los residuos recogidos" },
  { icon: Users, text: "Equipo operativo de Valoriza dedicado en exclusiva al municipio" },
];

export default function MissionSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="text-valoriza-green font-semibold text-sm uppercase tracking-widest">Nuestro compromiso</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-municipal mt-3 mb-6 leading-tight">
            Un municipio más limpio,
            <br /> gestionado por y para las personas
          </h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            El Ayuntamiento de San Fernando de Henares, junto a Valoriza Servicios
            Medioambientales, pone a disposición de los vecinos/as un servicio integral de
            recogida a domicilio de enseres y restos de poda, contribuyendo a un entorno
            urbano más sostenible y ordenado.
          </p>
          <div className="space-y-4">
            {POINTS.map((p, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-municipal/10 flex items-center justify-center shrink-0">
                  <p.icon className="w-5 h-5 text-municipal" />
                </div>
                <p className="text-gray-700 pt-1.5">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <div className="rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
            <img src={MISSION_IMAGE} alt="Servicio municipal" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-5 hidden sm:block">
            <p className="font-heading font-bold text-2xl text-valoriza-green">+10</p>
            <p className="text-xs text-gray-500 max-w-[140px]">años de colaboración con Valoriza</p>
          </div>
        </div>
      </div>
    </section>
  );
}
